const coursesEnum = [
  "Agronegocio",
  "Agronomia",
  "Cooperativismo",
  "Engenharia_Agricola_e_Ambiental",
  "Engenharia_Florestal",
  "Zootecnia",
  "Bioquimica",
  "Ciencias_Biologicas__Bacharelado_Licenciatura_",
  "Educacao_Fisica__Bacharelado_Licenciatura_",
  "Enfermagem",
  "Licenciatura_em_Ciencias_Biologicas__Noturno_",
  "Medicina",
  "Medicina_Veterinaria",
  "Nutricao",
  "Arquitetura_e_Urbanismo",
  "Ciencia_da_Computacaoo",
  "Ciencia_e_Tecnologia_de_Laticinios",
  "Engenharia_Ambiental",
  "Engenharia_Civil",
  "Engenharia_de_Agrimensura_e_Cartografica",
  "Engenharia_de_Alimentos",
  "Engenharia_de_Producao",
  "Engenharia_Eletrica",
  "Engenharia_Mecanica",
  "Engenharia_Quimica",
  "Fisica__Bacharelado_Licenciatura_",
  "Licenciatura_em_Fisica",
  "Licenciatura_em_Matematica",
  "Licenciatura_em_Quimica",
  "Matematica__Bacharelado_Licenciatura_",
  "Quimica__Bacharelado_Licenciatura_",
  "Administracao",
  "Ciencias_Contabeis",
  "Ciencias_Economicas",
  "Ciencias_Sociais__Bacharelado_Licenciatura_",
  "Comunicacao_Social___Jornalismo",
  "Danca__Bacharelado_Licenciatura_",
  "Direito",
  "Economia_Domestica",
  "Educacao_do_Campo",
  "Educacao_Infantil",
  "Geografia__Bacharelado_Licenciatura_",
  "Historia__Bacharelado_Licenciatura_",
  "Letras",
  "Pedagogia",
  "Secretariado_Executivo_Trilingue___Portugues__Frances_e_Ingles",
  "Servico_Social"
];

const coursesLabel = [
  "Agronegócio",
  "Agronomia",
  "Cooperativismo",
  "Engenharia Agrícola e Ambiental",
  "Engenharia Florestal",
  "Zootecnia",
  "Bioquímica",
  "Ciências Biológicas (Bacharelado/Licenciatura)",
  "Educação Física (Bacharelado/Licenciatura)",
  "Enfermagem",
  "Licenciatura em Ciências Biológicas (Noturno)",
  "Medicina",
  "Medicina Veterinária",
  "Nutrição",
  "Arquitetura e Urbanismo",
  "Ciência da Computação",
  "Ciência e Tecnologia de Laticínios",
  "Engenharia Ambiental",
  "Engenharia Civil",
  "Engenharia de Agrimensura e Cartográfica",
  "Engenharia de Alimentos",
  "Engenharia de Produção",
  "Engenharia Elétrica",
  "Engenharia Mecânica",
  "Engenharia Química",
  "Física (Bacharelado/Licenciatura)",
  "Licenciatura em Física",
  "Licenciatura em Matemática",
  "Licenciatura em Química",
  "Matemática (Bacharelado/Licenciatura)",
  "Química (Bacharelado/Licenciatura)",
  "Administração",
  "Ciências Contábeis",
  "Ciências Econômicas",
  "Ciências Sociais (Bacharelado/Licenciatura)",
  "Comunicação Social – Jornalismo",
  "Dança (Bacharelado/Licenciatura)",
  "Direito",
  "Economia Doméstica",
  "Educação do Campo",
  "Educação Infantil",
  "Geografia (Bacharelado/Licenciatura)",
  "História (Bacharelado/Licenciatura)",
  "Letras",
  "Pedagogia",
  "Secretariado Executivo Trilíngue – Português, Francês e Inglês",
  "Serviço Social"
];

const arr = coursesEnum.map((value, index) => {
  const label = coursesLabel[index];
  return {
    label,
    value
  };
});
export default arr;



// WEBPACK FOOTER //
// ./src/utils/UfvCourses.tsx